import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { FileText, Loader2 } from "lucide-react";

const FIELDS = [
  ["legal_name", "الاسم الرسمي للمنشأة", "rtl"],
  ["cr_number", "رقم السجل التجاري (10 أرقام)", "ltr"],
  ["vat_number", "الرقم الضريبي (15 رقم)", "ltr"],
  ["address", "العنوان", "rtl"],
];

export function InvoiceSettingsDialog() {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) api.get("/admin/invoice-settings").then((r) => setF(r.data));
  }, [open]);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.put("/admin/invoice-settings", f);
      toast.success("تم حفظ بيانات الفاتورة");
      setOpen(false);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" variant="outline" className="rounded-full gap-2" data-testid="invoice-settings-btn"><FileText className="w-4 h-4" /> بيانات الفاتورة</Button>
      </DialogTrigger>
      <DialogContent dir="rtl" data-testid="invoice-settings-dialog">
        <DialogHeader><DialogTitle>بيانات المنشأة في الفواتير</DialogTitle></DialogHeader>
        {!f ? <div className="py-8 text-center text-sm text-muted-foreground">جارٍ التحميل...</div> : (
          <form onSubmit={save} className="space-y-3">
            {FIELDS.map(([k, label, dir]) => (
              <div key={k} className="space-y-1.5"><Label>{label}</Label>
                <Input value={f[k]} dir={dir} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`invoice-${k}-input`} /></div>
            ))}
            <div className="flex items-center justify-between rounded-xl bg-muted/40 p-3">
              <div>
                <div className="text-sm font-semibold">تفعيل ضريبة القيمة المضافة 15%</div>
                <div className="text-xs text-muted-foreground">تصبح الفاتورة «فاتورة ضريبية مبسطة» مع رمز QR، والمبلغ المدفوع شامل الضريبة</div>
              </div>
              <Switch checked={f.vat_enabled} onCheckedChange={(v) => setF({ ...f, vat_enabled: v })} data-testid="invoice-vat-switch" />
            </div>
            <p className="text-xs text-muted-foreground">التغييرات تنطبق على الفواتير الجديدة فقط، والفواتير الصادرة تبقى كما هي.</p>
            <DialogFooter>
              <Button type="submit" disabled={busy} className="rounded-xl gap-2 w-full" data-testid="invoice-settings-save">
                {busy && <Loader2 className="w-4 h-4 animate-spin" />} حفظ
              </Button>
            </DialogFooter>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}
